import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { global } from "@shared/libs/Global";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import SnForm, { ValueChangedEvent } from "@widgets/SnForm";
import { fnGetDataSet } from "@shared/api/restApi";
import { showDialog } from "@widgets/CommonDialog";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_SAL_BAS_REG_001_POP_001 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    const { userInfo } = global();
    const formRef = useRef<any>(null);

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);

    const returnDataRef = useRef<any[]>([]);

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        return await getReturnData();
      },
      getOkayData: () => {
        return {
          rtnData: returnDataRef.current,
        };
      },
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_SAL_BAS_REG_001_POP_001",
            {}
          );
          setFormControlData(rtn.form.freeform1);
          setFormData(rtn.form.freeform1ControlData);
        } catch (error) {}
      };
      fetchform();
    }, []);

    const onValueChanged = (event: ValueChangedEvent) => {
      const { colId, newValue } = event;
      switch (colId) {
        case "tp_month":
          if (newValue === "1")
            return {
              tp_day: "0",
            };
          break;
        case "tp_day":
          if (newValue === "1")
            return {
              tp_month: "0",
            };
          break;
        case "tp_fixAmount":
          if (newValue === "1")
            return {
              tp_fixRate: "0",
            };
          break;
        case "tp_fixRate":
          if (newValue === "1")
            return {
              tp_fixAmount: "0",
            };
          break;
      }
    };

    const getReturnData = async () => {
      try {
        const formData = formRef.current.getFormdata();
        const params = {
          cd_firm: userInfo.cd_firm,
          cd_item: selectedData.cd_item,
          cd_module: selectedData.cd_module,
          cd_exch: formData.cd_exch,
          tp_um1: formData.tp_um1,
          tp_um2: formData.tp_um2,
          am: 0,
          separator1: 0,
          separator2: 0,
          dt_from: "",
          dt_to: "",
          dtDayStartCrt: "",
          dtDayEndCrt: "",
        };

        const tp_month = formData.tp_month;
        if (tp_month === "1") {
          // 월 기준
          const searchFirstDay = getMonthFirstDay(formData.search_date);
          const searchLastDay = getMonthLastDay(formData.search_date);
          const createFirstDay = getMonthFirstDay(formData.create_date);
          const createLastDay = getMonthLastDay(formData.create_date);

          // 조회월 < 생성월
          if (searchLastDay > createFirstDay) {
            await showDialog(
              "alter",
              "생성월은 조회월 이후로 설정해 주시기 바랍니다."
            );
            return false;
          }

          params.dt_from = searchFirstDay;
          params.dt_to = searchLastDay;
          params.dtDayStartCrt = createFirstDay;
          params.dtDayEndCrt = createLastDay;
        } else {
          // 일 기준
          // 조회일 < 생성일
          if (formData.search_to > formData.create_from) {
            await showDialog(
              "alter",
              "생성월은 조회월 이후로 설정해 주시기 바랍니다."
            );
            return false;
          }

          params.dt_from = formData.search_from;
          params.dt_to = formData.search_to;
          params.dtDayStartCrt = formData.create_from;
          params.dtDayEndCrt = formData.create_to;
        }
        const tp_fixAmount = formData["tp_fixAmount"];
        if (tp_fixAmount === "1") {
          // 정액
          params.separator1 = 0;
          params.separator2 = Number(formData.tp_sales1);
          params.am = Number(formData.am);
        } else {
          // 정률
          params.separator1 = 1;
          params.separator2 = Number(formData.tp_sales2);
          params.am = Number(formData.rt);
        }

        const param = {
          id: "sn_sal_bas_reg_001_pop_01_01",
          params: params,
        };

        const data: any = await fnGetDataSet(param);
        if (data && data[0].length === 0) {
          await showDialog(
            "alter",
            "조회기간내 적용가능 데이터가 존재하지 않습니다."
          );
          return false;
        }
        returnDataRef.current = data[0];
        return true;
      } catch (e) {
        return false;
      }
    };

    /**
     * 해당 월의 1일을 구하는 함수
     * YYYYMMDD → YYYYMM01
     * @param yyyymmdd
     */
    const getMonthFirstDay = (yyyymmdd: string) => {
      return yyyymmdd.substring(0, 6) + "01";
    };

    /**
     * 해당 월의 마지막 날을 구하는 함수
     * YYYYMMDD → YYYYMMDD(해당 월의 마지막 날)
     */
    const getMonthLastDay = (yyyymmdd: string) => {
      const year = Number(yyyymmdd.substring(0, 4));
      const month = Number(yyyymmdd.substring(4, 6));

      // 다음 달 0일 = 이번 달 마지막 날
      const lastDay = new Date(year, month, 0).getDate();

      return `${year}${String(month).padStart(2, "0")}${String(lastDay).padStart(2, "0")}`;
    };

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: 0,
        }}
      >
        <SnForm
          ref={formRef}
          data={formData}
          controls={formControlData}
          etcProps={{ popupRef: ref }}
          events={{ onValueChanged: onValueChanged }}
        />
      </div>
    );
  }
);

export default SN_SAL_BAS_REG_001_POP_001;
